import React from "react";
import classes from "./play-icon-scss";
const PlayIcon = () => {
  return /* @__PURE__ */ React.createElement("div", { className: classes.shadow }, /* @__PURE__ */ React.createElement("div", { className: classes.playIcon }));
};
export {
  PlayIcon
};
//# sourceMappingURL=play-icon.js.map
